module.exports = __webpack_public_path__ + "static/media/70.4e43c336.png";